import { Box, Button, Stack } from '@mui/material';
import { FC, ReactNode, useState } from 'react';
import { FilePdfIcon } from '../../../components/SvgIcons/FilePdfIcon';
import { exportFileTypes } from '../models/exportFileTypes';
import { ExportOptionsDialog } from './ExportOptionsDialog';

interface FooterButtonsProps {
  onSubmit: () => void;
  onReset: () => void;
}

interface FooterExtarButtonsProps {
  onSubmit: (file_type: exportFileTypes) => void;
  onReset: () => void;
  exportFileTypes?: ExportFileTypes;
}

export type ExportFileTypes = Array<{ label: string; value: string; icon: ReactNode }>;

export const FooterButtons: FC<FooterButtonsProps> = ({ onSubmit, onReset }) => {
  return (
    <Stack
      width="100%"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      p={'1.5rem'}
    >
      <Button onClick={onReset}>RESET</Button>
      <Button variant="contained" size="large" onClick={onSubmit}>
        Exporter en PDF
      </Button>
    </Stack>
  );
};

export const FooterExtraButtons: FC<FooterExtarButtonsProps> = ({
  onSubmit,
  onReset,
  exportFileTypes = [
    { label: 'PDF', value: 'pdf', icon: <FilePdfIcon sx={{ width: '3rem', height: '3rem' }} /> },
  ],
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleExport = (fileType: exportFileTypes) => {
    onSubmit(fileType);
  };

  const renderButtons = () => {
    if (exportFileTypes.length === 1) {
      return (
        <Button
          variant="contained"
          size="large"
          onClick={() => onSubmit(exportFileTypes[0].value as any)}
        >
          Exporter en {exportFileTypes[0].label}
        </Button>
      );
    }
    return (
      <>
        <Button variant="contained" size="large" onClick={handleOpenDialog}>
          Exporter
        </Button>
        <ExportOptionsDialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          onSubmit={handleExport}
          exportFileTypes={exportFileTypes}
        />
      </>
    );
  };

  return (
    <Stack
      width="100%"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      p={'1.5rem'}
    >
      <Button onClick={onReset}>RESET</Button>
      <Box>{renderButtons()}</Box>
    </Stack>
  );
};
